<template>
  <home-layout>
    <div class="container-fluid p-0">
      <div class="position-relative row m-0 align-items-start home-carrusel" style="z-index: 500; margin-top: 80px !important;">
        <div class="position-relative header-slider-grid">
          <div class="header-industriales-primero mt-5" style="z-index: 1000;">
            <div class="header-desktop">
              <img :src="ImgKraudLogo" width="450" alt="" />
            </div>
            <div class="home-carrusel-title mt-4 position-relative">Plataforma de inversión en bienes raíces industriales con componentes sustentables basada en blockchain.</div>
            <div class="home-carrusel-subtitle mt-4 position-relative">Invierte desde $1000 MXN</div>
            <div class="row m-0 global-width-100 home-center-button">
              <a href="/marketplace">
                <button class="home-carrusel-button" @mouseover="setStyle()" @mouseleave="deleteStyle()" :style="changeStyle">Ver propiedades <img v-if="changeStyle !== ''" :src="Vector10Stroke" /></button>
              </a>
            </div>
          </div>
          <div class="position-relative header-industriales-segundo mt-5" style="z-index: 200;">
            <div class="row m-0 position-relative justify-content-end global-width-100">
              <div class="home-carrusel-image">
                <img id="imgCarrusel" :src="SliderImg1" style="border-radius: 8px 8px 8px 8px;" alt="" />
                
              </div>
              <div class="row m-0 justify-content-end home-carrusel-container-img">
                <div v-show="Slider1" class="position-relative ml-3 mr-3" @click="carruselSelect(1)">
                  <a :href="url1">
                    <img :src="SliderImg1" alt="" :style="numberCounter === 1 ? 'border: 6px solid #9AEEC5;' : ''" />
                    <div :class="numberCounter === 1 ? '' : 'home-carrusel-opacity home-carrusel-container-img-normal'"></div>
                  </a>
                </div>
                <div v-show="Slider2" class="position-relative ml-2 mr-2" @click="carruselSelect(2)">
                  <a :href="url2">
                    <img :src="SliderImg2" alt="" :style="numberCounter === 2 ? 'border: 6px solid #9AEEC5;' : ''" />
                    <div :class="numberCounter === 2 ? '' : 'home-carrusel-opacity home-carrusel-container-img-normal'"></div>
                  </a>
                </div>
                <div v-show="Slider3" class="position-relative ml-3 mr-3" @click="carruselSelect(3)">
                  <a :href="url3">
                    <img :src="SliderImg3" alt="" :style="numberCounter === 3 ? 'border: 6px solid #9AEEC5;' : ''" />
                    <div :class="numberCounter === 3 ? '' : 'home-carrusel-opacity home-carrusel-container-img-normal'"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="home-ticker" height="60">
          <div class="ticker-wrapper-h">
              <ul class="news-ticker-h">
                <li v-for="(item, index) in cintillos" :key="index" class="row m-0" style="width: 370px; height: 60px;">
                  <div class="home-ticker-line ml-2 mr-3"></div>
                  <div class="home-ticker-title">{{item.attributes.text}}</div>
                  <div class="row m-0">
                    <div class="home-ticker-title ml-4">${{formatNumber(item.attributes.value)}}</div>
                    <div class="row m-0 align-items-center ml-2 home-ticker-string">
                      <div>{{item.attributes.percentage}}%</div>
                      <img :src="imgValor" class="ml-1" alt="" />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row m-0 justify-content-center" style="background-color: #F5FBFF;">
          <div class="home-container-industriales">
            <div style="height: auto;">
              <div class="home-industriales-title mb-3">Inversión segura en desarrollos <br /> industriales sustentables</div>
              <div class="position-relative">
                <div class="home-industriales-img" :style="'background: url(' + ImgBackIndustriales + ') center center/cover no-repeat #204B65;'"></div>
                <div class="position-absolute home-industriales-grid">
                  <div class="home-industriales-primero">
                    <div class="home-industriales-silver p-5">
                      <img :src="ImgIndustriales1" width="47" alt="" />
                      <div class="mt-4 home-industriales-card-title">Examina</div>
                      <div class="home-industriales-card-subtitle">Visualiza los datos financieros, informes de inspección y más. Todos los documentos de la propiedad están disponibles públicamente.</div>
                    </div>
                  </div>
                  <div class="home-industriales-segundo">
                    <div class="home-industriales-silver p-5">
                      <img :src="ImgIndustriales2" width="47" alt="" />
                      <div class="mt-4 home-industriales-card-title">Selecciona</div>
                      <div class="home-industriales-card-subtitle">Compra fracciones de propiedades de alquiler y conviértete en propietario directo.</div>
                    </div>
                  </div>
                  <div class="home-industriales-tercero">
                    <div class="home-industriales-silver p-5">
                      <img :src="ImgIndustriales3" width="47" alt="" />
                      <div class="mt-4 home-industriales-card-title">Gana alquiler y apreciación </div>
                      <div class="home-industriales-card-subtitle">Obtén pagos de alquiler diarios y cobra la apreciación de la propiedad cuando retires el dinero.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

  
        <div class="row m-0 justify-content-center pt-5" style="background-color: #F5FBFF;">
          <div class="position-relative home-container-industriales2">
            <div class="home-container-industriales3">
              <div class="home-industriales-title mb-3 text-center">Adquiere tu token</div>
              <div class="card-body">
                <section class="carousel">
                  <div>
                    <a :href="'/property-detail/' + this.property1.slug" >
                      <div v-show="showProperty1" class="position-relative" :style="'width: 100%; height: 400px; background: url(' + this.property1.urlImg + ') center center/cover no-repeat #204B65; border-radius: 4px;'">
                        <div class="home-carrusel-opacity home-token-hover row m-0 align-items-end" style="background: linear-gradient(180deg, rgba(13, 5, 26, 0) 0%, #0D051A 100%); z-index: 100;">
                          <div class="pl-2 pr-2 pb-5 global-width-100">
                            <button v-show="false" class="home-tag-button">Available: 2,149 tokens at $50</button>
                          </div>
                        </div>
                        <div class="position-absolute row m-0 p-2" style="top: 0px; z-index: 200;">
                          <div v-show="this.property1.isFeatured" class="home-tags-left-adquiere">FEATURED</div>
                          <div v-show="this.property1.isNewListening" class="home-tags-right-adquiere ml-2">New Listening</div>
                        </div>
                        <div class="position-absolute global-width-100" style="bottom: 100px; z-index: 200;">
                          <div class="row m-0 pl-2 pr-2">
                            <div class="position-relative home-tag-irr">{{ property1.IRR }} %IRR</div>
                            <div class="home-tag-irr-string pl-4">{{ property1.name }}</div>
                          </div>
                          <div class="row m-0 pl-2 pr-2">
                            <div class="position-relative home-tag-co">{{ property1.Coc }} %CoC</div>
                            <div class="home-tag-co-string pl-4">{{ property1.address }}</div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div>
                    <a :href="'/property-detail/' + this.property2.slug" >
                      <div v-show="showProperty2" class="position-relative" :style="'width: 100%; height: 415px; background: url(' + this.property2.urlImg + ') center center/cover no-repeat #204B65; border-radius: 4px;'">
                        <div class="home-carrusel-opacity home-token-hover row m-0 align-items-end" style="background: linear-gradient(180deg, rgba(13, 5, 26, 0) 0%, #0D051A 100%); z-index: 100;">
                          <div class="pl-2 pr-2 pb-5 global-width-100">
                            <button v-show="false" class="home-tag-button">Available: 2,149 tokens at $50</button>
                          </div>
                        </div>
                        <div class="position-absolute row m-0 p-2" style="top: 0px; z-index: 200;">
                          <div v-show="this.property2.isFeatured" class="home-tags-left-adquiere">FEATURED</div>
                          <div v-show="this.property2.isNewListening" class="home-tags-right-adquiere ml-2">New Listening</div>
                        </div>
                        <div class="position-absolute global-width-100" style="bottom: 100px; z-index: 200;">
                          <div class="row m-0 pl-2 pr-2">
                            <div class="position-relative home-tag-irr">{{ property2.IRR }} %IRR</div>
                            <div class="home-tag-irr-string pl-4">{{ property2.name }}</div>
                          </div>
                          <div class="row m-0 pl-2 pr-2">
                            <div class="position-relative home-tag-co">{{ property2.CoC }} %CoC</div>
                            <div class="home-tag-co-string pl-4">{{ property2.address }}</div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <!--div v-show="this.countProperties > 2 ? true : false" >
                    <div class="position-relative" :style="'width: 100%; height: 415px; background: url(' + this.property2.urlImg + ') center center/cover no-repeat #204B65; border-radius: 4px;'">
                      <div class="home-carrusel-opacity home-token-hover row m-0 align-items-end" style="background: linear-gradient(180deg, rgba(13, 5, 26, 0) 0%, #0D051A 100%); z-index: 100;">
                        <div class="pl-2 pr-2 pb-5 global-width-100">
                          <button v-show="false" class="home-tag-button">Available: 2,149 tokens at $50</button>
                        </div>
                      </div>
                      <div class="position-absolute row m-0 p-2" style="top: 0px; z-index: 200;">
                        <div v-show="this.property2.isFeatured" class="home-tags-left-adquiere">FEATURED</div>
                        <div v-show="this.property2.isNewListening" class="home-tags-right-adquiere ml-2">New Listening</div>
                      </div>
                      <div class="position-absolute global-width-100" style="bottom: 100px; z-index: 200;">
                        <div class="row m-0 pl-2 pr-2">
                          <div class="position-relative home-tag-irr">{{ property2.IRR }} %IRR</div>
                          <div class="home-tag-irr-string pl-4">{{ property2.name }}</div>
                        </div>
                        <div class="row m-0 pl-2 pr-2">
                          <div class="position-relative home-tag-co">{{ property2.CoC }} %CoC</div>
                          <div class="home-tag-co-string pl-4">{{ property2.address }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="this.countProperties > 3 ? true : false" >
                    <div class="position-relative" :style="'width: 100%; height: 415px; background: url(' + this.property2.urlImg + ') center center/cover no-repeat #204B65; border-radius: 4px;'">
                      <div class="home-carrusel-opacity home-token-hover row m-0 align-items-end" style="background: linear-gradient(180deg, rgba(13, 5, 26, 0) 0%, #0D051A 100%); z-index: 100;">
                        <div class="pl-2 pr-2 pb-5 global-width-100">
                          <button v-show="false" class="home-tag-button">Available: 2,149 tokens at $50</button>
                        </div>
                      </div>
                      <div class="position-absolute row m-0 p-2" style="top: 0px; z-index: 200;">
                        <div v-show="this.property2.isFeatured" class="home-tags-left-adquiere">FEATURED</div>
                        <div v-show="this.property2.isNewListening" class="home-tags-right-adquiere ml-2">New Listening</div>
                      </div>
                      <div class="position-absolute global-width-100" style="bottom: 100px; z-index: 200;">
                        <div class="row m-0 pl-2 pr-2">
                          <div class="position-relative home-tag-irr">{{ property2.IRR }} %IRR</div>
                          <div class="home-tag-irr-string pl-4">{{ property2.name }}</div>
                        </div>
                        <div class="row m-0 pl-2 pr-2">
                          <div class="position-relative home-tag-co">{{ property2.CoC }} %CoC</div>
                          <div class="home-tag-co-string pl-4">{{ property2.address }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="this.countProperties > 4 ? true : false" >
                    <div class="position-relative" :style="'width: 100%; height: 415px; background: url(' + this.property2.urlImg + ') center center/cover no-repeat #204B65; border-radius: 4px;'">
                      <div class="home-carrusel-opacity home-token-hover row m-0 align-items-end" style="background: linear-gradient(180deg, rgba(13, 5, 26, 0) 0%, #0D051A 100%); z-index: 100;">
                        <div class="pl-2 pr-2 pb-5 global-width-100">
                          <button v-show="false" class="home-tag-button">Available: 2,149 tokens at $50</button>
                        </div>
                      </div>
                      <div class="position-absolute row m-0 p-2" style="top: 0px; z-index: 200;">
                        <div v-show="this.property2.isFeatured" class="home-tags-left-adquiere">FEATURED</div>
                        <div v-show="this.property2.isNewListening" class="home-tags-right-adquiere ml-2">New Listening</div>
                      </div>
                      <div class="position-absolute global-width-100" style="bottom: 100px; z-index: 200;">
                        <div class="row m-0 pl-2 pr-2">
                          <div class="position-relative home-tag-irr">{{ property2.IRR }} %IRR</div>
                          <div class="home-tag-irr-string pl-4">{{ property2.name }}</div>
                        </div>
                        <div class="row m-0 pl-2 pr-2">
                          <div class="position-relative home-tag-co">{{ property2.CoC }} %CoC</div>
                          <div class="home-tag-co-string pl-4">{{ property2.address }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="this.countProperties > 5 ? true : false" >
                    <div class="position-relative" :style="'width: 100%; height: 415px; background: url(' + this.property2.urlImg + ') center center/cover no-repeat #204B65; border-radius: 4px;'">
                      <div class="home-carrusel-opacity home-token-hover row m-0 align-items-end" style="background: linear-gradient(180deg, rgba(13, 5, 26, 0) 0%, #0D051A 100%); z-index: 100;">
                        <div class="pl-2 pr-2 pb-5 global-width-100">
                          <button v-show="false" class="home-tag-button">Available: 2,149 tokens at $50</button>
                        </div>
                      </div>
                      <div class="position-absolute row m-0 p-2" style="top: 0px; z-index: 200;">
                        <div v-show="this.property2.isFeatured" class="home-tags-left-adquiere">FEATURED</div>
                        <div v-show="this.property2.isNewListening" class="home-tags-right-adquiere ml-2">New Listening</div>
                      </div>
                      <div class="position-absolute global-width-100" style="bottom: 100px; z-index: 200;">
                        <div class="row m-0 pl-2 pr-2">
                          <div class="position-relative home-tag-irr">{{ property2.IRR }} %IRR</div>
                          <div class="home-tag-irr-string pl-4">{{ property2.name }}</div>
                        </div>
                        <div class="row m-0 pl-2 pr-2">
                          <div class="position-relative home-tag-co">{{ property2.CoC }} %CoC</div>
                          <div class="home-tag-co-string pl-4">{{ property2.address }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="this.countProperties > 6 ? true : false" >
                    <div class="position-relative" :style="'width: 100%; height: 415px; background: url(' + this.property2.urlImg + ') center center/cover no-repeat #204B65; border-radius: 4px;'">
                      <div class="home-carrusel-opacity home-token-hover row m-0 align-items-end" style="background: linear-gradient(180deg, rgba(13, 5, 26, 0) 0%, #0D051A 100%); z-index: 100;">
                        <div class="pl-2 pr-2 pb-5 global-width-100">
                          <button v-show="false" class="home-tag-button">Available: 2,149 tokens at $50</button>
                        </div>
                      </div>
                      <div class="position-absolute row m-0 p-2" style="top: 0px; z-index: 200;">
                        <div v-show="this.property2.isFeatured" class="home-tags-left-adquiere">FEATURED</div>
                        <div v-show="this.property2.isNewListening" class="home-tags-right-adquiere ml-2">New Listening</div>
                      </div>
                      <div class="position-absolute global-width-100" style="bottom: 100px; z-index: 200;">
                        <div class="row m-0 pl-2 pr-2">
                          <div class="position-relative home-tag-irr">{{ property2.IRR }} %IRR</div>
                          <div class="home-tag-irr-string pl-4">{{ property2.name }}</div>
                        </div>
                        <div class="row m-0 pl-2 pr-2">
                          <div class="position-relative home-tag-co">{{ property2.CoC }} %CoC</div>
                          <div class="home-tag-co-string pl-4">{{ property2.address }}</div>
                        </div>
                      </div>
                    </div>
                  </div-->
                  
                  
                  
                  
                </section>
              </div>
              <div class="row m-0 justify-content-center global-width-100">
                <a href="/marketplace">
                  <button class="home-carrusel-button mt-2" @mouseover="setStyle()" @mouseleave="deleteStyle()" :style="changeStyle">Ver propiedades <img v-if="changeStyle !== ''" :src="Vector10Stroke" /></button>
                </a>
              </div>
            </div>
            <div class="home-opacity-bottom header-desktop"></div>
          </div>
        </div>
        <div class="home-container-invertir position-relative" :style="'background: url(' + ImgInvertir + ') center center/cover no-repeat #204B65;'">
          <div class="home-container-invertir-opacity"></div>
          <div class="home-container-invertir-opacity2"></div>
          <div class="position-relative">
            <div class="home-industriales-title mb-3 text-center" style="color: #F5FBFF; padding-top:60px;">¿Qué beneficios obtienes por invertir <br /> en Kraud?</div>
            <div class="global-width-100">
              <section class="regulars slider mt-4">
                <div v-show="false" style="width: 100%; height: 100%;">
                  <div style="width: 100%; height: 100%;">
                    <img :src="benefit1.img === 'Money'? ImgInvertir1 : benefit1.img === 'Shield' ? ImgInvertir2 : benefit1.img === 'Line' ? ImgInvertir3 : ImgInvertir4" style="width: 32px;" alt="" />
                  </div>
                  <div class="home-invertir-title mt-3">{{ benefit1.title }}</div>
                    <div class="home-invertir-subtitle mt-5">{{ benefit1.description }}</div>
                  </div>
                <div>
                  <div v-show="benefit2.isShow">
                    <div>
                      <img :src="benefit2.img === 'Money'? ImgInvertir1 : benefit2.img === 'Shield' ? ImgInvertir2 : benefit2.img === 'Line' ? ImgInvertir3 : ImgInvertir4" style="width: 32px;" alt="" />
                    </div>
                    <div class="home-invertir-title mt-3">{{ benefit2.title }}</div>
                    <div class="home-invertir-subtitle mt-5">{{ benefit2.description }}</div>
                  </div>
                </div>
                <div>
                  <div v-if="benefit3.isShow">
                  <div>
                    <img :src="benefit3.img === 'Money'? ImgInvertir1 : benefit3.img === 'Shield' ? ImgInvertir2 : benefit3.img === 'Line' ? ImgInvertir3 : ImgInvertir4" style="width: 32px;" alt="" />
                  </div>
                  <div class="home-invertir-title mt-3">{{ benefit3.title }}</div>
                  <div class="home-invertir-subtitle mt-5">{{ benefit3.description }}</div>
                </div>
                </div>
                <div>
                  <div v-if="benefit4.isShow">
                    <div>
                      <img :src="benefit4.img === 'Money'? ImgInvertir1 : benefit4.img === 'Shield' ? ImgInvertir2 : benefit4.img === 'Line' ? ImgInvertir3 : ImgInvertir4" style="width: 32px;" alt="" />
                    </div>
                    <div class="home-invertir-title mt-3">{{ benefit4.title }}</div>
                    <div class="home-invertir-subtitle mt-5">{{ benefit4.description }}</div>
                  </div>
                </div> 
                <div>
                  <div v-if="benefit5.isShow">
                    <div>
                      <img :src="benefit5.img === 'Money'? ImgInvertir1 : benefit5.img === 'Shield' ? ImgInvertir2 : benefit5.img === 'Line' ? ImgInvertir3 : ImgInvertir4" style="width: 32px;" alt="" />
                    </div>
                    <div class="home-invertir-title mt-3">{{ benefit5.title }}</div>
                    <div class="home-invertir-subtitle mt-5">{{ benefit5.description }}</div>
                  </div>
                </div>
                <div>
                  <div v-if="benefit6.isShow">
                    <div>
                      <img :src="benefit6.img === 'Money'? ImgInvertir1 : benefit6.img === 'Shield' ? ImgInvertir2 : benefit6.img === 'Line' ? ImgInvertir3 : ImgInvertir4" style="width: 32px;" alt="" />
                    </div>
                    <div class="home-invertir-title mt-3">{{ benefit6.title }}</div>
                    <div class="home-invertir-subtitle mt-5">{{ benefit6.description }}</div>
                  </div>
                </div>
                <div>
                  <div v-if="benefit7.isShow">
                    <div>
                      <img :src="benefit7.img === 'Money'? ImgInvertir1 : benefit7.img === 'Shield' ? ImgInvertir2 : benefit7.img === 'Line' ? ImgInvertir3 : ImgInvertir4" style="width: 32px;" alt="" />
                    </div>
                    <div class="home-invertir-title mt-3">{{ benefit7.title }}</div>
                    <div class="home-invertir-subtitle mt-5">{{ benefit7.description }}</div>
                  </div>
                </div>
                <div>
                  <div v-if="benefit8.isShow">
                    <div>
                      <img :src="benefit8.img === 'money'? ImgInvertir1 : benefit8.img === 'shield' ? ImgInvertir2 : benefit8.img === 'Line' ? ImgInvertir3 : ImgInvertir4" style="width: 32px;" alt="" />
                    </div>
                    <div class="home-invertir-title mt-3">{{ benefit8.title }}</div>
                    <div class="home-invertir-subtitle mt-5">{{ benefit8.description }}</div>
                  </div>
                </div>
              </section>
              <div class="row m-0 justify-content-center global-width-100">
                <a href="/marketplace">
                 <button class="home-carrusel-button mt-5" @mouseover="setStyle()" @mouseleave="deleteStyle()" :style="changeStyle">Ver propiedades <img v-if="changeStyle !== ''" :src="Vector10Stroke" /></button>
                </a>
                </div>
            </div>
          </div>
        </div>
        <div class="row m-0 align-items-center home-container-funciona-kraud">
          <div class="global-width-100 position-relative">
            <div class="home-funciona-right-title header-mobile">Como funciona <br /> <a style="color: #9747FF;"> Kraud </a></div>
            <div class="position-relative home-funciona-back-img">
              <img :src="valorDeveloper.img" alt="" />
              <div id="opacitySlider2" class="home-absolute-funciona-kraud header-mobile"></div>
            </div>
            <div class="home-absolute-funciona-kraud header-desktop"></div>
            <div class="home-funciona-back-right">
              <div class="row m-0 align-items-center" style="height: 100%;">
                <div class="position-relative" style="height: auto;">
                  <div class="home-funciona-right-title header-desktop">Como funciona <br /> <a style="color: #9747FF;"> Kraud </a></div>
                  <div class="row m-0 global-width-100 home-funciona-centers">
                    <div class="row m-0 home-funciona-options mt-4">
                      <div @click="changeOption(true)" :class="valiteOption ? 'home-funciona-option1' : 'home-funciona-option2'">SOY INVERSIONISTA</div>
                      <div @click="changeOption(false)" :class="!valiteOption ? 'home-funciona-option1' : 'home-funciona-option2'">SOY DESARROLLADOR</div>
                    </div>
                  </div>
                  <div v-if="valiteOption" class="row m-0">
                    <div class="mt-3 pr-5 home-funciona-width-content">
                      <div class="home-funciona-right-title2">{{valorDeveloper.title}}</div>
                      <div class="home-funciona-right-title3 mt-3">{{valorDeveloper.subtitle}}</div>
                      <div class="home-funciona-right-title4 mt-3">{{valorDeveloper.description}}</div>
                    </div>
                    <div class="home-funciona-one header-desktop" style="width: 30px;">
                      <div @click="changeSubOption(0)" :class="validateSubOption === 0 ? 'home-funciona-start' : ''">1</div>
                      <div @click="changeSubOption(1)" :class="validateSubOption === 1 ? 'home-funciona-center' : ''">2</div>
                      <div @click="changeSubOption(2)" :class="validateSubOption === 2 ? 'home-funciona-center' : ''">3</div>
                      <div @click="changeSubOption(3)" :class="validateSubOption === 3 ? 'home-funciona-end' : ''">4</div>
                    </div>
                    <div class="header-mobile global-width-100 mt-4">
                      <div class="row m-0 justify-content-center global-width-100">
                        <div class="row m-0 home-funciona-horizontal">
                          <div @click="changeSubOption(0)" :class="validateSubOption === 0 ? 'home-funciona-start2' : 'home-funciona-start3'">1</div>
                          <div @click="changeSubOption(1)" :class="validateSubOption === 1 ? 'home-funciona-center2' : 'home-funciona-start3'">2</div>
                          <div @click="changeSubOption(2)" :class="validateSubOption === 2 ? 'home-funciona-center2' : 'home-funciona-start3'">3</div>
                          <div @click="changeSubOption(3)" :class="validateSubOption === 3 ? 'home-funciona-end2' : 'home-funciona-start3'">4</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!valiteOption" class="row m-0">
                    <div class="mt-3 pr-5 home-funciona-width-content">
                      <div class="home-funciona-right-title2">{{valorDeveloper.title}}</div>
                      <div class="home-funciona-right-title3 mt-3">{{valorDeveloper.subtitle}}</div>
                      <div class="home-funciona-right-title4 mt-3">{{valorDeveloper.description}}</div>
                    </div>
                    <div class="home-funciona-one header-desktop" style="width: 30px;">
                      <div @click="changeSubOption(0)" :class="validateSubOption === 0 ? 'home-funciona-start' : ''">1</div>
                      <div @click="changeSubOption(1)" :class="validateSubOption === 1 ? 'home-funciona-center' : ''">2</div>
                      <div @click="changeSubOption(2)" :class="validateSubOption === 2 ? 'home-funciona-center' : ''">3</div>
                      <div @click="changeSubOption(3)" :class="validateSubOption === 3 ? 'home-funciona-end' : ''">4</div>
                    </div>
                    <div class="header-mobile global-width-100 mt-4">
                      <div class="row m-0 justify-content-center global-width-100">
                        <div class="row m-0 home-funciona-horizontal">
                          <div @click="changeSubOption(0)" :class="validateSubOption === 0 ? 'home-funciona-start2' : 'home-funciona-start3'">1</div>
                          <div @click="changeSubOption(1)" :class="validateSubOption === 1 ? 'home-funciona-center2' : 'home-funciona-start3'">2</div>
                          <div @click="changeSubOption(2)" :class="validateSubOption === 2 ? 'home-funciona-center2' : 'home-funciona-start3'">3</div>
                          <div @click="changeSubOption(3)" :class="validateSubOption === 3 ? 'home-funciona-end2' : 'home-funciona-start3'">4</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row m-0 justify-content-center home-center-aprendizaje pt-4">
          <div class="home-center-container p-3">
            <div class="global-width-100" style="height: 50px;">
              <div class="float-left home-aprendizaje-title">Centro de aprendizaje</div>
              <div  @click="goTo('/blog')" class="float-right">
                <img :src="ImgVector" alt="" />
              </div>
            </div>
            <div class="home-line-white"></div>
            <div class="row m-0">
              <div  v-for="(item, index) in posts" :key="index" class="home-center-col">
               
                <div style="cursor:pointer;" @click="goTo('/blog/' + item.attributes.slug)" class="position-relative p-3">
                  
                <img :src="item.attributes.featuredImage.data.attributes.formats.thumbnail.url" width="100%" alt="" />
                 
                  <div class="row m-0 align-items-end home-aprendizaje-card-absolute pb-4 pl-2 pr-2">
                    <div class="home-aprendizaje-inversiones">
                        {{ item.attributes.category.data.attributes.CategoryName }}
                    </div>
                  </div>
                </div>
             
                <div class="home-aprendizaje-title2 p-3">
                  <router-link :to="'/blog/' + item.attributes.slug">{{ item.attributes.Title }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="false" class="position-relative row m-0 align-items-center justify-content-center home-width-start pb-5" :style="'background: url(' + ImgNaves + ') center center/cover no-repeat #204B65;'">
          <div class="home-width-start-absolute row m-0">
            <div class="global-width-100 pt-5 pb-5 header-desktop">
              <img id="valueGraph" :src="Animation1" width="100%" style="max-height: 550px;" alt="" />
            </div>
          </div>
          <div class="position-relative" style="height: auto;">
            <div class="home-start-text-title text-center">¿Listo para <br /> comenzar?</div>
            <div class="row m-0 justify-content-center global-width-100 mt-5 pt-5">
              <button class="home-carrusel-button mt-5" @mouseover="setStyle()" @mouseleave="deleteStyle()" :style="changeStyle">Comienza invertir <img v-if="changeStyle !== ''" :src="Vector10Stroke" /></button>
            </div>
          </div>
        </div>
      </div>
      <header-info :isHome=true></header-info>
      <footer-info></footer-info>
  </home-layout>
</template>

<script>


import HomeLayout from '@/layouts/HomeLayout'
import HeaderInfo from '@/components/HeaderInfo'
import FooterInfo from '@/components/FooterInfo'
import ImgKraudLogo from '@/assets/header/logo_kraud.svg'
import imgValor from '@/assets/home/imgvalor.png'
import {getId} from '@/services/returnVal'
import ImgBackIndustriales from '@/assets/home/img-back-industriales.jpg'
import ImgIndustriales1 from '@/assets/home/img-industriales1.png'
import ImgIndustriales2 from '@/assets/home/img-industriales2.png'
import ImgIndustriales3 from '@/assets/home/img-industriales3.png'
import ImgSmall01 from '@/assets/home/img-011.jpg'
import ImgSmall02 from '@/assets/home/img-071.jpg'
import ImgSmall03 from '@/assets/home/img-021.jpg'
import ImgVector from '@/assets/home/Vector10.png'
import ImgNaves1 from '@/assets/home/naves-industriales-mexico1.jpg'
import Img01 from '@/assets/home/image1.jpg'
import Img02 from '@/assets/home/image2.jpg'
import AnimationHart from '@/assets/home/Animationchart.svg'
import ImgNaves from '@/assets/home/naves-industriales-mexico2.jpg'
import Animation1 from '@/assets/home/animation1.png'
import Animation2 from '@/assets/home/animation2.png'
import Animation3 from '@/assets/home/animation3.png'
import Animation4 from '@/assets/home/animation4.png'
import Animation5 from '@/assets/home/animation5.png'
import ImgInvertir from '@/assets/home/img-invertir.jpg'
import ImgInvertir1 from '@/assets/home/ImgInvertir1.png'
import ImgInvertir2 from '@/assets/home/ImgInvertir2.png'
import ImgInvertir3 from '@/assets/home/ImgInvertir3.png'
import ImgInvertir4 from '@/assets/home/ImgInvertir4.png'
import Industriales1 from '@/assets/home/industriales1.png'
import Industriales2 from '@/assets/home/industriales2.png'
import Industriales3 from '@/assets/home/industriales3.png'
import Industriales4 from '@/assets/home/industriales4.png'
import Vector10Stroke from '@/assets/home/Vector10Stroke.png'
import {getCintillos, getCarrusel, getLearningCenter, getProperties, getBenefits} from '@/services/home'
import numeral from "numeral"
import CardItem from '@/components/CardItem.vue'
export default {
  name: 'Home',
  props: {
  },
  data () {
    return {
      showProperty2:false,
      showProperty1:false,
      property1: {
        name: '',
        address: '',
        imgUrl: '',
        IRR:0,
        Coc:0,
        isFeatured: false,
        isNewListening: false,
        slug:''
      },
      property2: {
        name: '',
        address: '',
        imgUrl: '',
        IRR:0,
        CoC:0,
        isFeatured: false,
        isNewListening: false,
        slug:''
      },
      posts:[],
      cintillos:[],
      ImgKraudLogo: ImgKraudLogo,
      SliderImg1: "",
      SliderImg2: "",
      SliderImg3: "",
      Slider1: false,
      Slider2: false,
      Slider3: false,
      url1: '',
      url3: '',
      url2: '',
      countSlider:0,
      properties:[],
      countProperties:0,
      imgValor: imgValor,
      numberCounter: 1,
      setIntervalValue : '',
      ImgBackIndustriales: ImgBackIndustriales,
      ImgIndustriales1: ImgIndustriales1,
      ImgIndustriales2: ImgIndustriales2,
      ImgIndustriales3: ImgIndustriales3,
      ImgSmall01: ImgSmall01,
      ImgSmall02: ImgSmall02,
      ImgSmall03: ImgSmall03,
      ImgVector: ImgVector,
      ImgNaves1: ImgNaves1,
      Img01: Img01,
      Img02: Img02,
      AnimationHart: AnimationHart,
      ImgNaves: ImgNaves,
      Animation1: Animation1,
      Animation2: Animation2,
      Animation3: Animation3,
      Animation4: Animation4,
      Animation5: Animation5,
      temporizadorDato: '',
      counterGraph: 1,
      ImgInvertir: ImgInvertir,
      ImgInvertir1: ImgInvertir1,
      ImgInvertir2: ImgInvertir2,
      ImgInvertir3: ImgInvertir3,
      ImgInvertir4:ImgInvertir4,
      Industriales1: Industriales1,
      Industriales2: Industriales2,
      Industriales3: Industriales3,
      Industriales4: Industriales4,
      valiteOption: true,
      validateSubOption: 0,
      dataBenefits:null,
      benefit1: {
        title: '',
        description: '',
        isShow: false,
        img: ''
      },
      benefit2: {
        title:null,
        description: '',
        isShow: false,
        img: ''
      },
      benefit3: {
        title:null,
        description: '',
        isShow: false,
        img: ''
      },
      benefit4: {
        title:null,
        description: '',
        isShow: false,
        img: ''
      },
      benefit5: {
        title:null,
        description: '',
        isShow: null,
        img: ''
      },
      benefit6: {
        title:'',
        description: '',
        isShow: false,
        img: ''
      },
      benefit7: {
        title:'',
        description: '',
        isShow: false,
        img: ''
      },
      benefit8: {
        title:'',
        description: '',
        isShow: false,
        img: ''
      },
      valorDeveloper: {
        img: '',
        title: '',
        subtitle: '',
        description: ''
      },
      countBenefits: 0,
      valorInvestorAll: [
        {
          img: '',
          title: 'Paso 1',
          subtitle: 'Selección de la propiedad',
          description: 'Todas las propiedades en Kraud son evaluadas para definir su viabilidad. Por lo que cada proyecto contará con la información necesaria no solo para que puedas evaluar la parte financiera y de mercado, sino también verificar todo el sustento legal y de esta forma puedas seleccionar el proyecto que mejor se adecue a tus necesidades de manera segura.'
        },
        {
          img: '',
          title: 'Paso 2',
          subtitle: 'Compra de tokens',
          description: 'Todas las propiedades en Kraud son evaluadas para definir su viabilidad. Por lo que cada proyecto contará con la información necesaria no solo para que puedas evaluar la parte financiera y de mercado, sino también verificar todo el sustento legal y de esta forma puedas seleccionar el proyecto que mejor se adecue a tus necesidades de manera segura.'
        },
        {
          img: '',
          title: 'Paso 3',
          subtitle: 'Cuál es tu riesgo',
          description: 'En cualquier inversión, existe un riesgo asociado. En el caso de las inversiones en Kraud el riesgo esta en la tasa de desocupación (cuando no está rentado el inmueble) y por ende no hayan ingresos. Sin embargo Kraud ha pensado en eso resolviéndolo de dos formas: A) Dentro del monto de inversión existe un fondo de desocupación el cual se irá devengando cuando no exista un arrendatario y B) Kraud cuenta con un equipo dedicado a comercializar las propiedades. Toma en cuenta que mientras está en proceso de construcción obviamente no recibirás renta.'
        },
        {
          img: '',
          title: 'Paso 4',
          subtitle: 'Recibe tus rentas',
          description: 'En el proceso para darte de alta en Kraud te pediremos tus datos bancarios para que en cuanto paguen la renta, a ti se te disperse tu pago correspondiente y proporcional al monto de tu inversión. Comúnmente son pagos mensuales, pero es posible que esta condición cambie dependiendo el proyecto.'
        }
      ],
      valorDeveloperAll: [
        {
          img: '',
          title: 'Paso 1',
          subtitle: 'Propiedad enviada',
          description: 'Un desarrollador envía su proyecto para ser sometido a la evaluación de viabilidad de inversión. El desarrollador debe contar con un terreno y cumplir  en forma con todos los requerimientos no solo de posesión sino también de información acerca de su proyecto.'
        },
        {
          img: '',
          title: 'Paso 2',
          subtitle: 'Propiedad puesta bajo contrato',
          description: 'Una vez aprobado el proyecto de desarrollo, estos son procesados legalmente para formar una entidad moral que permita la inclusión de inversionistas en diferentes series de acciones. Al mismo tiempo se hace la oferta de Tokens de seguridad basados en blockchain para demostrar la participación en la inversión ya sea por la cesión del terreno o la aportación de capital. A ti como dueño del terreno se te asignarán Tokens.'
        },
        {
          img: '',
          title: 'Paso 3',
          subtitle: 'Recaudación de fondos',
          description: 'Kraud ayuda a la recaudación de los fondos necesarios para el desarrollo del proyecto a través de inversionistas. Cuando los fondos se recaudan, se inicia la construcción del proyecto. A través de esas entidades legales creadas para cada proyecto, Kraud se asegura que los fondos sean usados adecuadamente. El monto total de inversión incluye un rubro por desocupación.'
        },
        {
          img: '',
          title: 'Paso 4',
          subtitle: 'Comercialización de propiedades',
          description: 'El equipo de Kraud trabaja para conseguir a los arrendatarios para que en cuanto se concluya la construcción la propiedad se ocupe inmediatamente. En este punto, Kraud será encargado de la administración y mantenimiento.'
        }
      ],
      Vector10Stroke: Vector10Stroke,
      changeStyle: ''
    }
  },
  methods: {
    getProperties() {
      getProperties().then((response) =>{
        if (response.error) {
          if (response.error.name === 'ValidationError') {
            this.showData = false
            this.showError = true
          }
        }
        else {
          console.log(response.data.data)
          this.properties = response.data.data
          this.countProperties = response.data.data.length
          console.log("countProperties", this.countProperties)
          if (this.countProperties > 0) {

            let financialData = this.properties[0].attributes.property_financial.data.attributes
           
            this.showProperty1 = true
            if(this.properties[0].attributes.Images.data[0].attributes.formats.medium) {
              this.property1.urlImg = this.properties[0].attributes.Images.data[0].attributes.formats.medium.url
            }
            else if(this.properties[0].attributes.Images.data[0].attributes.formats.small) {
              this.property1.urlImg = this.properties[0].attributes.Images.data[0].attributes.formats.small.url
            }
            else {
              this.property1.urlImg= this.properties[0].attributes.Images.data[0].attributes.url
            }
            this.property1.name = this.properties[0].attributes.Name
            this.property1.address = this.properties[0].attributes.Address
            this.property1.IRR = financialData.IRR
            this.property1.Coc = financialData.Coc
            this.property1.isFeatured = this.properties[0].attributes.isFeatured
            this.property1.isNewListening = this.properties[0].attributes.isNewListening
            this.property1.slug = this.properties[0].attributes.slug
          }

          if (this.countProperties > 1) {
            this.showProperty2 = true
            let financialData2 = this.properties[1].attributes.property_financial.data.attributes
            if(this.properties[1].attributes.Images.data[0].attributes.formats.medium) {
              this.property2.urlImg = this.properties[1].attributes.Images.data[0].attributes.formats.medium.url
            }
            else if(this.properties[1].attributes.Images.data[0].attributes.formats.small) {
              this.property2.urlImg = this.properties[1].attributes.Images.data[0].attributes.formats.small.url
            }
            else {
              this.property2.urlImg= this.properties[1].attributes.Images.data[0].attributes.url
            }
            this.property2.name = this.properties[1].attributes.Name
            this.property2.address = this.properties[1].attributes.Address
            this.property2.IRR = financialData2.IRR
            this.property2.CoC = financialData2.Coc
            this.property2.isFeatured = this.properties[1].attributes.isFeatured
            this.property2.isNewListening = this.properties[1].attributes.isNewListening
            this.property2.slug = this.properties[1].attributes.slug
            }
          //this.resizeCarrousel()
        }
      })
    },
    goTo(url) {
      window.location.href = url
    },
    getLearningCenter() {
      getLearningCenter().then((response) => { 
        this.posts = response.data.data.attributes.articles.data
      })
    },
    formatNumber(value) {
      return numeral(value).format("0,0")
    },
    getBenefits() {
      getBenefits().then((response) => {
           
            if (response.error) {
              
            } else {
              this.dataBenefits = response.data.data.attributes
              console.log('BENEFITS', response.data.data.attributes)
              if (this.dataBenefits.Title) {
                this.benefit1.title = this.dataBenefits.Title
                this.benefit1.description = this.dataBenefits.Description
                this.benefit1.img = this.dataBenefits.TypeImage
                this.benefit1.isShow = true
                this.countBenefits = this.countBenefits + 1
              }
              if (this.dataBenefits.Title2) {
                this.benefit2.title = this.dataBenefits.Title2
                this.benefit2.description = this.dataBenefits.Description2
                this.benefit2.img = this.dataBenefits.TypeImage2
                this.benefit2.isShow = true
                this.countBenefits = this.countBenefits + 1
              }
              if (this.dataBenefits.Title3) {
                this.benefit3.title = this.dataBenefits.Title3
                this.benefit3.description = this.dataBenefits.Description3
                this.benefit3.img = this.dataBenefits.TypeImage3
                this.benefit3.isShow = true
              }
              if (this.dataBenefits.Title4) {
                this.benefit4.title = this.dataBenefits.Title4
                this.benefit4.description = this.dataBenefits.Description4
                this.benefit4.img = this.dataBenefits.TypeImage4
                this.benefit4.isShow = true
                this.countBenefits = this.countBenefits + 1
              }
              if (this.dataBenefits.Title5) {
                this.benefit5.title = this.dataBenefits.Title5
                this.benefit5.description = this.dataBenefits.Description5
                this.benefit5.img = this.dataBenefits.TypeImage5
                this.benefit5.isShow = true
                this.countBenefits = this.countBenefits + 1
              }
              if (this.dataBenefits.Title6) {
                this.benefit6.title = this.dataBenefits.Title6
                this.benefit6.description = this.dataBenefits.Description6
                this.benefit6.img = this.dataBenefits.TypeImage6
                this.benefit6.isShow = true
                this.countBenefits = this.countBenefits + 1
              }
              if (this.dataBenefits.Title7) {
                this.benefit7.title = this.dataBenefits.Title7
                this.benefit7.description = this.dataBenefits.Description7
                this.benefit7.img = this.dataBenefits.TypeImage7
                this.benefit7.isShow = true
                this.countBenefits = this.countBenefits + 1
              }
              if (this.dataBenefits.Title8) {
                this.benefit8.title = this.dataBenefits.Title8
                this.benefit8.description = this.dataBenefits.Description8
                this.benefit8.img = this.dataBenefits.TypeImage8
                this.benefit8.isShow = true
                this.countBenefits = this.countBenefits + 1
              }
            }
            console.log('this.countBenefits', this.countBenefits)
            if (this.countBenefits < 5) {
              let v = document.getElementsByClassName("slick-dots")
              console.log(v[0])
              v[0].style.display = "none"
            } 
      })
    },
    getCintillo() {
      getCintillos().then((response) => {
           
            if (response.error) {
              if (response.error.name === 'ValidationError') {
                this.showData = false
                this.showError = true
                this.messageErrorLogin = "Invalid password or email, try again"
              } else if (response.data.message === 'PASS') {
                this.showData = false
                this.showError = true
                this.messageErrorLogin = 'La contraseña que has introducido es incorrecta. ¿Has olvidado la contraseña?'
              }
            } else {
              this.isValid = true
              this.cintillos = response.data.data
            
            }
      })
    },
    getCarrusel() {
      getCarrusel().then((response) => {
           
            if (response.error) {
              if (response.error.name === 'ValidationError') {
                this.showData = false
                this.showError = true
                this.messageErrorLogin = "Invalid password or email, try again"
              } else if (response.data.message === 'PASS') {
                this.showData = false
                this.showError = true
                this.messageErrorLogin = 'La contraseña que has introducido es incorrecta. ¿Has olvidado la contraseña?'
              }
            } else {
              this.isValid = true
              console.log(response.data)
              this.SliderImg1 = response.data.data.attributes.Image1.data.attributes.url
              this.url1 = '/property-detail/' + response.data.data.attributes.property1.data.attributes.slug
             
              if (this.SliderImg1.length > 10) {
                this.countSlider = this.countSlider + 1 
                this.Slider1 = true
              }
                
              
              if (response.data.data.attributes.Image2.data){
                this.SliderImg2 = response.data.data.attributes.Image2.data.attributes.url
                this.url2 = '/property-detail/' +  response.data.data.attributes.property2.data.attributes.slug
                this.Slider2 = true
                this.countSlider = this.countSlider + 1 
              }
                
              
              if (response.data.data.attributes.Image3.data ){
                console.log("imge3",response.data.data.attributes.Image3)
                this.SliderImg3 = response.data.data.attributes.Image3.data.attributes.url
                this.url3 = '/property-detail/' +  response.data.data.attributes.property3.data.attributes.slug
                this.Slider3 = true
                this.countSlider = this.countSlider + 1 
              }

              this.carrusel()
                
            }
      })
    },
    deleteStyle () {
      this.changeStyle = ''
    },
    setStyle () {
      this.changeStyle = 'background-color: #0D051A;'
    },
    changeInvestorValue (value) {
      if (value === 0) {
        this.valorDeveloper.img = this.Industriales1
      } else if (value === 1) {
        this.valorDeveloper.img = this.Industriales2
      } else if (value === 2) {
        this.valorDeveloper.img = this.Industriales3
      } else if (value === 3) {
        this.valorDeveloper.img = this.Industriales4
      }
      this.valorDeveloper.title = this.valorInvestorAll[value].title
      this.valorDeveloper.subtitle = this.valorInvestorAll[value].subtitle
      this.valorDeveloper.description = this.valorInvestorAll[value].description
    },
    changeDeveloperValue (value) {
      if (value === 0) {
        this.valorDeveloper.img = this.Industriales4
      } else if (value === 1) {
        this.valorDeveloper.img = this.Industriales3
      } else if (value === 2) {
        this.valorDeveloper.img = this.Industriales2
      } else if (value === 3) {
        this.valorDeveloper.img = this.Industriales1
      }
      this.valorDeveloper.title = this.valorDeveloperAll[value].title
      this.valorDeveloper.subtitle = this.valorDeveloperAll[value].subtitle
      this.valorDeveloper.description = this.valorDeveloperAll[value].description
    },
    changeSubOption (value) {
      this.validateSubOption= value
      if (this.valiteOption) {
        this.changeInvestorValue(value)
      } else {
        this.changeDeveloperValue(value)
      }
    },
    changeOption (value) {
      this.valiteOption = value
      if (value) {
        this.changeSubOption(0)
        this.changeInvestorValue(0)
      } else {
        this.changeSubOption(0)
        this.changeDeveloperValue(0)
      }
    },
    comenzarTemporizador () {
      const vm = this
      this.temporizadorDato = setInterval(function () {
        if (vm.counterGraph === 5) {
          vm.counterGraph = 1
        } else {
          vm.counterGraph = vm.counterGraph + 1
        }
        if (vm.counterGraph === 1) {
          getId('valueGraph').src = vm.Animation1
        } else if (vm.counterGraph === 2) {
          getId('valueGraph').src = vm.Animation2
        } else if (vm.counterGraph === 3) {
          getId('valueGraph').src = vm.Animation3
        } else if (vm.counterGraph === 4) {
          getId('valueGraph').src = vm.Animation4
        } else if (vm.counterGraph === 5) {
          getId('valueGraph').src = vm.Animation5
        }
      }, 900)
    },
    carruselSelect (value) {
      this.numberCounter = value
      getId('imgCarrusel').setAttribute('class', 'dropdown4')
      if (value === 1) {
        getId('imgCarrusel').src = this.SliderImg1
      } else if (value === 2) {
        getId('imgCarrusel').src = this.SliderImg2
      } else if (value === 3) {
        getId('imgCarrusel').src = this.SliderImg3
      }
      setTimeout(function () {
        getId('imgCarrusel').setAttribute('class', '')
      }, 1000)
      clearInterval(this.setIntervalValue)
      this.carrusel()
    },
    carrusel () {  //No es el carrusel es el que esta al
      const vm = this
      console.log("slider",vm.countSlider)
      
      if (this.countSlider > 1){
        console.log("Entrando")
        this.setIntervalValue = setInterval(function () {
          getId('imgCarrusel').setAttribute('class', 'dropdown4')

          console.log("Entrando",vm.numberCounter ,"<", vm.countSlider)
          if (vm.numberCounter < vm.countSlider) {
            console.log("Entrando 2")
            vm.numberCounter = vm.numberCounter + 1
            if (vm.numberCounter === 1) {
              console.log("Entro al 1")
              getId('imgCarrusel').src = vm.SliderImg1
            } else if (vm.numberCounter === 2 ) {
              console.log("Entro al 2")
              getId('imgCarrusel').src = vm.SliderImg2
            } else if (vm.numberCounter === 3 ) {
              console.log("Entro al 3")
              getId('imgCarrusel').src = vm.SliderImg3
            }
          } else {
            vm.numberCounter = 1
            getId('imgCarrusel').src = vm.SliderImg1
          }
          setTimeout(function () {
            getId('imgCarrusel').setAttribute('class', '')
          }, 1000)
        }, 6000)
      }
    },
    resizeCarrousel () {
      console.log("resizeCarrousel")
      $('.carousel').slick({
          centerMode: true,
          slidesToShow: 5,
          slidesToScroll: 2,
          arrows: true,
          dots: true,
          speed: 300,
          infinite: true,
          autoplaySpeed: 30000,
          autoplay: true,
          responsive: [
          {
              breakpoint: 1600,
              settings: {
                centerMode: true,
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1600,
              settings: {
                centerMode: true,
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1300,
              settings: {
                centerMode: true,
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1100,
              settings: {
                centerMode: true,
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 900,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      });
      $(".regulars").slick({
        centerMode: false,
        dots: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
              breakpoint: 1100,
              settings: {
                centerMode: false,
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 900,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      });
    
    this.changeInvestorValue(0)
    }
  }
  ,
  beforeCreate () {
    
  },
  created () {
    this.getProperties()
    this.getCarrusel()
    this.getCintillo()
    this.getLearningCenter()
    $(document).on('load', function() {
      $('.carousel').slick({
          centerMode: true,
          slidesToShow: 5,
          slidesToScroll: 2,
          arrows: true,
          dots: true,
          speed: 300,
          infinite: true,
          autoplaySpeed: 30000,
          autoplay: true,
          responsive: [
          {
              breakpoint: 1600,
              settings: {
                centerMode: true,
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1600,
              settings: {
                centerMode: true,
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1300,
              settings: {
                centerMode: true,
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1100,
              settings: {
                centerMode: true,
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 900,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      });
      $(".regulars").slick({
        centerMode: false,
        dots: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
              breakpoint: 1100,
              settings: {
                centerMode: false,
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 900,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      });
    });
    this.changeInvestorValue(0)
  },
  mounted () {
    this.comenzarTemporizador()
    this.getBenefits()
    //this.resizeCarrousel ()
    document.addEventListener("DOMContentLoaded", this.resizeCarrousel, false)
    
  },
  components: {
    HomeLayout,
    HeaderInfo,
    FooterInfo,
    CardItem
  }
}
</script>
